// extracted by mini-css-extract-plugin
module.exports = {"maxWidthWrapper":"MaxWidthWrapper_maxWidthWrapper__1QkTd"};